// extracted by mini-css-extract-plugin
export default {"root":"ToolbarButton_root__B7WoV"};